import { useState } from "react";
import { UploadIcon } from "components/icons";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Required CSS for the carousel

import { dropCases } from "data/drop-cases";

export type CarouselItem = {
  image: string;
  title: string;
  description: string;
};

export const DragCard = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  return (
    <div className="flex flex-col items-center justify-center py-[32px] md:py-[64px] px-[16px] md:px-[23px] w-full h-full max-w-[544px] rounded-tl-[12px] rounded-tr-[12px] border border-dashed border-[#94A3B8] bg-[#F8FAFC]">
      <div className="flex flex-col items-center justify-center">
        <UploadIcon />
        <p className="mt-4 text-[#737373] font-medium text-[16px] md:text-[18px] text-center">
          Drop your image to start editing ...
        </p>
      </div>

      {dropCases.length > 0 && (
        <div className="flex flex-col items-center justify-center my-[32px]">
          <Carousel
            autoPlay={false}
            interval={3000} // 3-second timer
            transitionTime={800} // Fade transition duration
            infiniteLoop
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            showThumbs={false}
            emulateTouch
            swipeable
            className="w-fit h-fit"
            onChange={(index) => {
              setCurrentIndex(index);
            }}
            // animationHandler="fade" // Fade-in animation
          >
            {dropCases.map((item) => (
              <img
                src={item.image}
                alt={item.title}
                className="w-[200px] h-[200px] object-contain rounded-lg"
              />
            ))}
          </Carousel>

          <div className="flex flex-col items-center justify-center">
            <h2 className="text-[16px] md:text-[18px] font-medium text-[#171717] text-center mt-[18px]">
              {dropCases[currentIndex].title}
            </h2>
            <p className="mt-1 text-[14px]  text-center text-[#525252]">
              {dropCases[currentIndex].description}
            </p>
          </div>
        </div>
      )}

      <p className="text-[#525252] text-[12px] text-center">
        Supported formats: JPG, PNG, WEBP • Max size: 10MB • Min resolution:
        512x512px
      </p>
    </div>
  );
};
